window.Webflow = window.Webflow || [];
window.Webflow.push(() => {
  const orderForm = document.getElementById('ORDERFORM') as HTMLFormElement;

  // if user comes from "hinnat" with pre-selected plan, it will save as query param "selected"
  const urlParams = new URLSearchParams(window.location.search);
  const selectedValue = urlParams.get('selected');

  const radioButtons = document.querySelectorAll<HTMLInputElement>('input[name="Versio"]');

  const kayttokoulutusMini = document.getElementById('Mini') as HTMLInputElement;
  const kayttokoulutusPerus = document.getElementById('Perus') as HTMLInputElement;
  const kayttokoulutusLaaja = document.getElementById('Laaja') as HTMLInputElement;
  const miniParent = kayttokoulutusMini.previousSibling as HTMLElement;

  // if pre-selected value is not Lite, require and pre-check the kayttokoulutusMini checkbox.
  if (selectedValue === 'Lite') {
    kayttokoulutusMini.required = false;
    kayttokoulutusMini.checked = false;
  } else if (selectedValue !== 'Lite') {
    kayttokoulutusMini.required = true;
    kayttokoulutusMini.checked = true;
    miniParent.classList.add('w--redirected-checked');
  }

  // For each Plan radio button, run this
  radioButtons.forEach((radioButton: HTMLInputElement) => {
    const parentElement = radioButton.closest('.radio-button-field');
    const labelElement = parentElement?.previousElementSibling;
    const radioElement = radioButton.previousElementSibling;

    // check the plan-radio button that has the same value as the pre-selected plan.
    if (selectedValue) {
      if (selectedValue && radioButton.value === selectedValue) {
        radioButton.checked = true;
        parentElement?.classList.add('cc-selected');
        labelElement?.classList.add('cc-selected');
        radioElement?.classList.add('w--redirected-checked');
      } else {
        radioButton.checked = false;
        radioButton.removeAttribute('[checked="checked"]');
        parentElement?.classList.remove('cc-selected');
        labelElement?.classList.remove('cc-selected');
        radioElement?.classList.remove('w--redirected-checked');
      }
    }

    // listen to each plan radio button change events
    radioButton.addEventListener('change', () => {
      // first, remove all cc-selected classes from each radio button field
      document.querySelectorAll('.radio-button-field').forEach((element: Element) => {
        element.classList.remove('cc-selected');
      });

      // second, remove all cc-selected classes from each radio button label field
      document.querySelectorAll('.chosen-plan-label-wrapper').forEach((element: Element) => {
        element.classList.remove('cc-selected');
      });

      // for the radio button that had been pressed, add checked and cc-selected to it and it's parent
      if (parentElement) {
        radioButton.checked = true;
        parentElement.classList.add('cc-selected');
        labelElement?.classList.add('cc-selected');
      }

      // if selected plan is not lite, require and pre-check mini kayttokoulutus.
      if (radioButton.value === 'Lite') {
        kayttokoulutusMini.required = false;
        kayttokoulutusMini.checked = false;
        miniParent.classList.remove('w--redirected-checked');
      } else if (radioButton.value !== 'Lite') {
        kayttokoulutusMini.required = true;
        kayttokoulutusMini.checked = true;
        miniParent.classList.add('w--redirected-checked');
      }
    });
  });

  // if user selects perus kayttokoulutus, don't require mini
  kayttokoulutusPerus.addEventListener('change', () => {
    if (kayttokoulutusPerus.checked || kayttokoulutusLaaja.checked) {
      kayttokoulutusMini.required = false;
    } else {
      kayttokoulutusMini.required = true;
    }
  });

  // if user selects laaja kayttokoulutus, don't require mini
  kayttokoulutusLaaja.addEventListener('change', () => {
    if (kayttokoulutusLaaja.checked || kayttokoulutusPerus.checked) {
      kayttokoulutusMini.required = false;
    } else {
      kayttokoulutusMini.required = true;
    }
  });

  const billingMethodInput = document.getElementById('Laskutustapa') as HTMLInputElement;
  const verkkolaskuosInput = document.getElementById('Verkkolaskuosoite') as HTMLInputElement;
  const verkkolaskuopInput = document.getElementById('Verkkolaskuoperaattori') as HTMLInputElement;
  const velosWrapper = document.getElementById('vl-os-wrapper') as HTMLElement;
  const velopWrapper = document.getElementById('vl-op-wrapper') as HTMLElement;
  verkkolaskuosInput.required = true;
  verkkolaskuopInput.required = true;

  // if user changes the billing method, run this.
  billingMethodInput.addEventListener('change', () => {
    // if billing method is einvoice, make einvoice inputs required and visible, else: hide and make them not required
    if (billingMethodInput.value === 'EINVOICE') {
      verkkolaskuosInput.required = true;
      verkkolaskuopInput.required = true;
      velosWrapper.classList.remove('hide');
      velopWrapper.classList.remove('hide');
    } else if (billingMethodInput.value !== 'EINVOICE') {
      verkkolaskuosInput.required = false;
      verkkolaskuopInput.required = false;
      velosWrapper.classList.add('hide');
      velopWrapper.classList.add('hide');
    }
  });

  if (orderForm) {
    // Function to handle form submission
    async function handleSubmit(event: Event) {
      event.preventDefault(); // Prevent the form from submitting normally

      // Get the form data
      const formData = new FormData(orderForm);

      try {
        // Send the form data to your backend API
        const response = await fetch('https://pipedrive-api.eetu-rantanen.workers.dev/', {
          method: 'POST',
          body: formData,
        });

        // Check if the request was successful
        if (response.ok) {
          // Redirect the user to the desired page
          window.location.href = '/kiitos';
        } else {
          // Handle the error case
          console.error('Form submission failed');
          // Display an error message to the user or take appropriate action
        }
      } catch (error) {
        // Handle any network or server errors
        console.error('An error occurred:', error);
        // Display an error message to the user or take appropriate action
      }
    }
    orderForm.addEventListener('submit', handleSubmit);
  }
});
